import React, { Fragment } from 'react';
import _ from 'lodash';

import { Confirmation } from './common';
import { messageUtility } from '../../utilities/messageUtility';

const RegisteredCompaniesDialog = ({
  visible,
  registeredCompanies,
  companyName,
  companyAddress,
  oneMasterTypeNameCompanyNumber,
  onCancel,
  onConfirm,
  title = '登録内容を確認してください',
}) => {
  const renderMessage = () => {
    return (
      <Fragment>
        <div className='dialog__row'>
          <p className='dialog__text-box dialog__text'>
            {messageUtility.getMessage('I-000-150')}{' '}
            <span className='dialog__text dialog__text--large'>
              {_.get(_.head(registeredCompanies), 'user_name') || ''}
            </span>{' '}
            {messageUtility.getMessage('I-000-151')}
          </p>
        </div>
        <div className='dialog__row'>
          <ul>
            {_.map(_.slice(registeredCompanies, 0, 5), company => {
              // すでに所属している会社がある場合は、ここにリストを最大5件表示
              return (
                <li
                  className='dialog__text dialog__text--large'
                  key={company.id}
                >
                  <span className='dialog__text_company__row'>
                    {company.name}
                  </span>
                </li>
              );
            })}
          </ul>
        </div>
        <div className='dialog__row'>
          <p className='dialog__text-box dialog__text'>
            <span className='dialog__text dialog__text--large'>
              {_.get(_.head(registeredCompanies), 'user_name') || ''}
            </span>
            {messageUtility.getMessage('I-000-152')}
          </p>
          <span className='dialog__text-box dialog__text dialog__text--large text--red--primary dialog__text_company__row'>
            {companyName}
          </span>
          <p className='dialog__text-box dialog__text text--red--primary dialog__text_company__row'>
            {oneMasterTypeNameCompanyNumber}
            <br />
            {companyAddress}
          </p>
          <p className='dialog__text-box dialog__text'>
            {messageUtility.getMessage('I-000-153')}
          </p>
        </div>
      </Fragment>
    );
  };

  return (
    <Fragment>
      <Confirmation
        visible={visible}
        message={renderMessage()}
        onCancel={onCancel}
        onConfirm={onConfirm}
        title={title}
        cancelButtonText={messageUtility.getMessage('I-000-017')}
        confirmButtonText={messageUtility.getMessage('I-000-154')}
        effectiveButtonClassName='btn-fixedsize--effective'
        rootClassName='dialog dialog--wide dialog--dialog-partner-user-invite-mail'
      />
    </Fragment>
  );
};

export default RegisteredCompaniesDialog;



// WEBPACK FOOTER //
// ./src/components/modals/RegisteredCompaniesDialog.jsx